











import {Component, Vue} from 'vue-property-decorator';

@Component
export default class MainView extends Vue {
  public get homeViewBgClass() {
    return this.$route.name === 'home' ? 'grey lighten-5' : '';
  }

  public get isMicroApp() {
    return this.$route.meta.isMicroApp;
  }

  public get name() {
    return this.$route.name;
  }

  public get url() {
    return this.$route.meta.url;
  }

  public get defaultPage() {
    return this.$route.meta.defaultPage;
  }

}
